import Link from "next/link";
import Button from "../../../Atoms/Button";
import styles from "./ThankYou.module.scss";

export default function ThankYou() {
  return (
    <div className={styles.thankYouContainer}>
      <h2
        style={{
          fontWeight: "500",
          fontSize: "40px",
        }}
      >
        Thank you!
      </h2>
      <h3 className={styles.thankYouMessage}>
        {
          "Your inquiry has been sent to our customer service team.\nWe will get back to you shortly."
        }
      </h3>

      <Link href="/">
        <Button
          style={{
            width: "300px",
            fontSize: "16px",
            margin: "25px 0 30px 0",
          }}
        >
          Back to MagicalTrip
        </Button>
      </Link>
    </div>
  );
}
